const userSsoAssignmentConfig = {
  name: 'User SSO Assignment',
  endpoint: '/internal_admin/admin_kit/user_sso_assignments',
  modelKey: 'user_sso_assignment',
  titleField: 'user_email',

  columns: [
    { name: 'user_email', title: 'User', type: 'link' },
    { name: 'provider_label', title: 'Provider' },
    { name: 'created_at', title: 'Created' },
  ],

  filters: [
    { name: 'q[user_email_cont]', label: 'User Email' },
    {
      name: 'q[provider_eq]',
      label: 'Provider',
      options: (props) => props.providers ?? [],
    },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    { name: 'user_email', label: 'User Email' },
    { name: 'provider_label', label: 'Provider' },
    { name: 'notes', label: 'Notes' },
    { name: 'created_at', label: 'Created At' },
    { name: 'updated_at', label: 'Updated At' },
  ],

  form: {
    fields: [
      {
        name: 'user_uuid',
        label: 'User',
        type: 'typeahead',
        searchEndpoint:
          '/internal_admin/admin_kit/user_sso_assignments/user_search',
        displayField: 'user_email',
        helpMessage: 'Search by email or username (min 2 characters)',
      },
      {
        name: 'provider',
        label: 'Provider',
        type: 'select',
        options: (props) => props.providers ?? [],
      },
      { name: 'notes', label: 'Notes', type: 'textarea', rows: 3, span: 2 },
    ],
  },
};

export default userSsoAssignmentConfig;
